import viVN from 'antd/lib/locale/vi_VN';

import activityLog from './activityLog';
import adminAccount from './adminAccount';
import auth from './auth';
import common from './common';
import Form from './form';
import pageError from './pageError';
import roles from './roles';
import server from './server';
import user from './user';
import userGroup from './userGroup';
import applications from './applications';
import documents from './documents';

export default {
  ...viVN,
  ...common,
  ...userGroup,
  ...activityLog,
  ...server,
  ...auth,
  ...pageError,
  ...roles,
  ...user,
  ...adminAccount,
  ...applications,
  ...documents,
  Form,
};
